import Homepage from "./Homepage";
import Helmet from "react-helmet";
import React, {useEffect} from "react";
import {useNavigate} from "react-router-dom";

const HomepageCopy = () => {
    const Navigate = useNavigate();

    useEffect(() => {
        setTimeout(()  => {
            Navigate('/')
        }, 3000)
    }, []);

    return (
        <div>
            <Homepage></Homepage>
            <Helmet>
                <meta name="robots" content={"nofollow, noindex"}/>
            </Helmet>
        </div>


    )
}

export default HomepageCopy;